@if (patronSelectors.loaded | select) {
  <div class="my-card-header">
    <div class="flex-row-wrap-col-responsive flex-center-start flex-gap-30">
      <div class="my-card-title mat-headline-4">My Library Card</div>
      @if (patronStatusSelectors.isExpired | select) {
        @if (patronStatusSelectors.underMaxBalance | select) {
          <div class="my-card-message">
            <div class="mat-small">Your account is in good standing.</div>
            <button id="renewAccountBtn" class="mat-raised-button mat-primary" (click)="renewAccount()">
              Renew Account
            </button>
          </div>
        } @else {
          <div class="my-card-message">
            <div class="mat-small">You must settle your account before you may renew.</div>
            <a class="pointer" (click)="routingService.goToPatronBilling()">Go to billing</a>
          </div>
        }
      }
    </div>
  </div>
  <div class="my-card-section flex-row-wrap-col-responsive flex-center-start flex-gap-30">
    <mat-card appearance="outlined" class="my-card-front mat-elevation-z3">
      @if (organizationSelectors.organization | select; as organization) {
        <h3 class="my-card-lib-name">
          @if (organization.iconUrl) {
            <img [alt]="organization.name" [src]="organization.iconUrl"/>
          } @else {
            <img alt="Millonex Logo" src="/assets/mx-logo.png"/>
          }
          {{ organization.name }}
        </h3>
      }
      @if (branchSelectors.branch | select; as branch) {
        <div class="my-card-details mat-small">
          @if (branch.address && branch.phone) {
            <span>{{ branch.address }}</span><br/>
            @if (branch.address2) {
              <span>{{ branch.address2 }}<br/></span>
            }
            <span>{{ branch.city }}, {{ branch.state }} {{ branch.zipCode }}</span><br/>
            <span>{{ branch.phone }}</span>
          } @else {
            <span>1234 Street Name</span><br/>
            <span>City, ST, 12345</span><br/>
            <span>123-456-7790</span>
          }
        </div>
      }
      <h2 class="my-card-patron-name">
        {{ patronSelectors.firstName | select }} {{ patronSelectors.lastName | select }}
      </h2>
    </mat-card>
    @if (patronSelectors.barcode | select; as barcode) {
      <mat-card appearance="outlined" class="my-card-back mat-elevation-z3">
        <div class="my-card-barcode">
          <ngx-barcode [bc-value]="barcode" [bc-display-value]="false"/>
        </div>
        <div class="mat-small">
          {{ barcode ? barcode : '0000 0000 0000 0000' }}
        </div>
        <div class="my-card-expiration mat-small">
          <span>Expiration Date: {{ patronSelectors.accountExpiration | select | date: 'M/d/y' }}</span>
        </div>
      </mat-card>
    }
  </div>
}
